import Http from '@/plugins/http.js';
import JSEncrypt from 'jsencrypt';
import systemService from '@/services/system-service';

export default {
    //获取个人资料信息
    getPersonalFile(userCode) {
        return Http.GET(`api/Organization/GetUserInfoByCode/${userCode}`);
    },
    //获取个人资料信息的逻辑
    getUserFile() {
        return Http.GET('api/System/GetFieldSets/User');
    },
    //更新个人资料
    updateUserInfo(parameters) {
        return Http.POST('api/Organization/UpdateUserInfo', parameters);
    },
    //修改密码
    async changePassword(userId, newPass, oldPass) {
        //newPass = encodeURIComponent(newPass); //uri编码处理特殊字符
        let { PublicKey } = await systemService.getSystemSetting();
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(PublicKey);
        if (oldPass) {
            let param = {
                Uid: userId,
                Pwd:encrypt.encrypt(newPass),   
                OldPwd:encrypt.encrypt(oldPass),  
            };
            return Http.POST(`api/Organization/ChangePassword`,param);
        } else {
            let param = {
                Uid: userId,
                Pwd:encrypt.encrypt(newPass), 
            };
            return Http.POST(`api/Organization/ChangePasswordAdmin`,param);
        }
    },
};